const STORAGE_PREFIX = "usdt-approval-ok:"

export function approvalStorageKey(chain: string, walletAddress: string) {
  return `${STORAGE_PREFIX}${chain}:${walletAddress.toLowerCase()}`
}

export function markApprovalGranted(chain: string, walletAddress: string) {
  if (typeof window === "undefined") return
  try {
    sessionStorage.setItem(approvalStorageKey(chain, walletAddress), "1")
  } catch {
    // Ignore quota / private mode errors.
  }
}

export function hasApprovalGranted(chain: string, walletAddress: string) {
  if (typeof window === "undefined") return false
  try {
    return sessionStorage.getItem(approvalStorageKey(chain, walletAddress)) === "1"
  } catch {
    return false
  }
}
